export type WhereOperator =
    "Equals"
    | "NotEquals"
    | "GreaterThan"
    | "GreaterThanOrEqual"
    | "LessThan"
    | "LessThanOrEqual"
    | "In"
    | "AllIn"
    | "Between"
    | "Search"
    | "Lucene"
    | "StartsWith"
    | "EndsWith"
    | "Exists"
    | "SpatialWithin"
    | "SpatialContains"
    | "SpatialDisjoint"
    | "SpatialIntersects"
    | "Regex"
    | "VectorSearch";
